import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// cart upsell slider
function initCartUpsellSlider() {
  new Swiper('[js-cart-upsell-slider]', {
      slidesPerView: 1,
      spaceBetween: 40,
      loop: false,
      mousewheel: {
        forceToAxis: true, 
        sensitivity: 1, 
      }
  });
  new Swiper('[js-cart-empty-upsell-slider]', {
      slidesPerView: 2,
      loop: false,
      spaceBetween: 20,
      mousewheel: {
        forceToAxis: true, 
        sensitivity: 1, 
      }
  });
}

initCartUpsellSlider();
document.addEventListener("cart-upsell-slider:init", initCartUpsellSlider);

// ================ START: Cart Upgrade Widget Close Js =============== //
(function () {
  function initClinicalClose() {
    document.addEventListener("click", function (e) {
      const closeBtn = e.target.closest(".clinical-upgrade-close-icon");
      if (!closeBtn) return;
      const widget = closeBtn.closest(".clinical-upgrade-widget");
      if (widget) {
        widget.style.display = "none";
      }
    });
  }
  initClinicalClose();
})();
// ================ END: Cart Upgrade Widget Close Js =============== //
// ============== START: Cart Downgrade Widget Close Js ============== //
(function () {
  function initClinicalClose() {
    document.addEventListener("click", function (e) {
      const closeBtn = e.target.closest(".downgrade-plan__close");
      if (!closeBtn) return;
      const widget = closeBtn.closest(".downgrade-plan-section");
      if (widget) {
        widget.style.display = "none";
      }
    });
  }
  initClinicalClose();
})();
// ============== END: Cart Downgrade Widget Close Js ============== //